var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 33,
    viewBox: "0 0 42 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4462 29.8853C23.1757 28.2659 26.0465 26.303 28.0585 23.9966C30.0704 21.7392 31.0764 19.7272 31.0764 17.9606C31.0764 17.0282 30.9292 16.194 30.6348 15.4579C30.4876 15.0653 29.8251 14.2802 28.6473 13.1024C27.4696 11.9247 26.7826 11.115 26.5863 10.6733C26.2428 9.83907 26.071 8.88215 26.071 7.80255C26.071 5.64335 26.8071 3.80312 28.2793 2.28187C29.7515 0.760613 31.4445 -1.44222e-05 33.3583 -1.45895e-05C35.3703 -1.47654e-05 37.1615 0.809685 38.7318 2.42909C40.253 4.04849 41.0137 6.08501 41.0137 8.53864C41.0137 12.9061 39.2961 17.3227 35.861 21.7883C32.4259 26.2539 27.4451 29.7135 20.9184 32.1672L19.4462 29.8853Z",
    fill: "#111516"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-9.36596e-05 29.8853C3.72944 28.2659 6.60019 26.303 8.61218 23.9966C10.6242 21.7392 11.6301 19.7272 11.6301 17.9606C11.6301 17.0282 11.4829 16.194 11.1885 15.4579C11.0413 15.0653 10.3788 14.2802 9.20105 13.1024C8.0233 11.9247 7.33628 11.115 7.13999 10.6733C6.79648 9.83907 6.62473 8.88215 6.62473 7.80255C6.62473 5.64335 7.36082 3.80312 8.833 2.28187C10.3052 0.760613 11.9982 -1.44222e-05 13.912 -1.45895e-05C15.924 -1.47654e-05 17.7152 0.809685 19.2855 2.42909C20.8068 4.04849 21.5674 6.08501 21.5674 8.53864C21.5674 12.9061 19.8498 17.3227 16.4147 21.7883C12.9796 26.2539 7.99877 29.7135 1.47209 32.1672L-9.36596e-05 29.8853Z",
    fill: "#111516"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.f9542b7c800a1239aae00518c3fea140.svg";
export { ForwardRef as ReactComponent };